import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import SubCategoryListLayer from "../components/SubCategoryListLayer";

const SubCategoryListPage = () => {
    return (
        <MasterLayout>
            <SubCategoryListLayer />
        </MasterLayout>
    );
};

export default SubCategoryListPage;
